import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';

import {
  isAdminSelector,
  isAuthenticatedSelector,
  userSelector,
} from 'redux/selectors/authenticationSelectors';
import { useAppSelector } from 'hooks/useAppSelector';

type Props = {
  [propName: string]: any;
};

// A wrapper for <Route> that redirects to the welcome page
// if user is authenticated and hasn't completed profile setup
export default function ProfileSetupRoute(props: Props) {
  const { children, ...rest } = props;
  const isAuthenticated = useAppSelector(isAuthenticatedSelector);
  const user = useAppSelector(userSelector);
  const isAdminRole = useAppSelector(isAdminSelector);
  const location = useLocation();
  const shouldFillInitialProfileSetup =
    !user?.isProfileComplete && !isAdminRole;

  return isAuthenticated && shouldFillInitialProfileSetup ? (
    <Navigate to="/welcome" state={{ from: location }} />
  ) : (
    <Outlet {...rest} />
  );
}